import React from 'react';
import { StyleSheet, ScrollView, Text } from 'react-native';

import { ListItem } from '@rneui/themed';
import { AntDesign } from '@expo/vector-icons';

import FormField from 'ui/form/FormField';
import ItemForm from './ItemForm';
import { type TableType } from 'types/Table';

const styles = StyleSheet.create({
  container: {
    width: '100%',
    justifyContent: 'center',
  },
});

interface Props {
  value: TableType | null;
  title?: string;
  tableList: TableType[];
  setFieldValue?: (item: TableType) => void;
  disabled: boolean;
}

const ItemListForm: React.FC<Props> = ({
  value: _value,
  title,
  tableList,
  setFieldValue,
  disabled = false,
}) => {
  const [expanded, setExpanded] = React.useState(false);

  return (
    <ListItem.Accordion
      content={
        <ListItem.Content>
          <ListItem.Title>
            <Text>{title}</Text>
          </ListItem.Title>
        </ListItem.Content>
      }
      isExpanded={expanded}
      onPress={() => {
        setExpanded(!expanded);
      }}
      icon={<AntDesign name="up" size={24} color="black" />}
      style={styles.container}
      disabledStyle={{ backgroundColor: 'lightgray' }}
      disabled={disabled}
    >
      <ScrollView>
        {tableList.map((item, key) => (
          <ItemForm
            item={item}
            key={key}
            setFieldValue={setFieldValue}
            expanded={expanded}
            setExpanded={setExpanded}
          />
        ))}
      </ScrollView>
    </ListItem.Accordion>
  );
};

export default FormField(ItemListForm);
